module.exports = __webpack_public_path__ + "img/active-booking.f16ceede.svg";